import styled from 'styled-components'

import { Button } from 'components/Button'
import { Container } from 'components/Container'

import { Color } from 'root-constants'

export const StyledCheckInbox = {
  Container: styled(Container)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    padding: 0 16px;
    overflow: auto;
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;

    width: 100%;

    padding: 0 8px;
    overflow: auto;
  `,
  Title: styled.h2`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;

    color: ${Color.BLUE_DARK};

    margin: 32px 0 8px;
  `,
  Text: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;

    color: ${Color.GRAY};

    &:not(:last-of-type) {
      margin: 0 0 8px;
    }
  `,
  Footer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;

    padding-bottom: 40px;
  `,
  Button: styled(Button)`
    width: 100%;
    height: 48px;

    border: none;
    border-radius: 48px;
    background-color: ${Color.INK_DARKEST};

    font-size: 16px;
    font-weight: 500;
    line-height: 16px;

    color: ${Color.GOLD_LIGHTER};

    padding: 0 16px;
  `,
}
